import FileUploadsService from '@/infrastructure/fileuploads/services/FileUploadsService'
import ProjectService from '@/taskflex/projects/services/ProjectService'

import {
  SET_ALL_FILES,
  SET_PROJECT_FILES,
  SET_ORIGINAL_FILENAME,
  SET_IS_LOADING,
} from './_types'

export default {
  setOriginalFilename ({ commit }, originalFilename) {
    commit(SET_ORIGINAL_FILENAME, originalFilename)
  },
  getAllFiles ({ commit }) {
    return new Promise((resolve, reject) => {
      FileUploadsService.getAllFiles(
        response => {
          const { data } = response
          commit(SET_ALL_FILES, data)

          resolve(data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getProjectFiles ({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      ProjectService.files(
        projectId,
        [],
        response => {
          const { data } = response
          commit(SET_PROJECT_FILES, data)

          resolve(data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  removeFile ({ state }, fileId) {
    return new Promise((resolve, reject) => {
      FileUploadsService.deleteFile(
        fileId,
        response => {
          if (response.status === 200) {
            // Delete successful
            state.files.project = state.files.project.filter(
              file => file.id !== fileId
            )
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadFile ({ state }, fileId) {
    return new Promise((resolve, reject) => {
      FileUploadsService.downloadFile(
        fileId,
        { 'Cache-Control': 'no-cache' },
        response => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          })

          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = state.original_filename
          link.click()
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  uploadFile ({ state }, data) {
    return new Promise((resolve, reject) => {
      FileUploadsService.uploadFile(
        data,
        response => {
          state.files.project = [...state.files.project, response.data];
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  setIsLoading({ commit }, isLoading) {
    commit(SET_IS_LOADING, isLoading);
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/fileuploads/store/_actions.js